<template>
  <div class="myoldHeaders home-topp">
    <div class="home-top">
      <div class="maxwidth " :class="{'maxnoneWidth':minwith == 1 || routerType == 6 ,'filterbgs':grayTheme && routerPath =='/'  }">
        <div class="header_logo">
          <div class="grid-content bg-purple1" style="cursor: pointer" @click="chePage(1)">
              <img class="biglogo"  src="https://oss.ansongqiubo.com/website/longzhulive.png" alt="" />
              <img class="minlogo" src="/static/newroom/minlogins.png" alt="" />
          </div>
          <div class="nav_leftitem">
            <div class="itemName" :class="routerType == 1 && routerPath =='/' ? 'activeItem' : ''" @click="chePage(1)">
              首页
            </div>
            <div class="itemName" :class="routerPath == '/roominfo' || routerPath ==  '/pageLive' ? 'activeItem' : ''"
              @click="chePage(4)">
              直播
            </div>
            <el-popover placement="bottom" trigger="hover"
              popper-class="popScopeSelectBox">
            				<div class="dioalogBox">
            					<div class="footBall u-flex u-flex-items-center u-flex-center"  @click="goScoreHome(1)">
            						 足球比分
            					</div>
            					<div class="footBall"  @click="goScoreHome(2)">
            						篮球比分
            					</div>
            				</div>
                    <div slot="reference"  class="itemName" :class="routerType == 2 ? 'activeItem' : ''" >
                      即时比分<i style="font-size: 14px;color: #000;" class="el-icon-arrow-down"></i>
                    </div>
            </el-popover>

            <!--  <div class="itemName" :class="routerType == 3 ? 'activeItem' : ''" @click="chePage(3)">
              资讯中心
            </div> -->
             <div class="itemName" :class="routerType == 100 ? 'activeItem' : ''" @click="getActives">
                活动
              </div>
          </div>
        </div>
        <div class="right_nav">
<!--          <div class="grid-content bg-purple-light">
            <input v-model="sousuoxinxi" @keyup.enter="sousuo" autocomplete="new-password" class="bg-purple-light-input"
              placeholder="按昵称搜索主播" />
            <input class="hidden_input" />
            <div class="home-search" @click="sousuo">搜索</div>
          </div> -->
          <div class="grid-content bg-purple2">
            <div class="nav_item u-flex-y elementHove" style="display: flex;flex-direction:column;align-items: center;justify-content: center;" :class="routerType == 9 ? 'activeItem' : ''" @click="chePage(9)">
              <img style="width: 20px;height: 20px;" class="oldel" src="@/assets/img/nav/kaibo1.png" alt="" srcset="">
              <img style="width: 20px;height: 20px;" class="newel" src="@/assets/img/nav/kaibo2.png" alt="" srcset="">
              <span style="font-size: 14px;">开播</span>
            </div>
            <div>
              <el-popover  placement="top-end" width="400" trigger="hover" popper-class="popDownAPPs">
                  <div class="downAPP " :class="{'filterbgs':grayTheme && routerPath =='/'  }">
                      <div class="liveHelps">
                        <span style="margin-bottom: 15px;" class="livetitles">开播助手</span>
                        <img src="@/assets/img/downhelpIcon.png" alt="" srcset="">
                         <span style="margin-top: 15px;" class="liveDowns"><a class="liveDowns" href="https://online-lz.oss-accelerate.aliyuncs.com/obs/release/lzLiveSetup.exe"> 点击下载</a></span>
                      </div>
                      <div class="lines"></div>
                      <div class="itemAPP">
                        <span  class="livetitles">神龙直播</span>
                        <img src="https://online-lz.oss-accelerate.aliyuncs.com/apk/iosUploadQrcode/SL-QR.jpeg?Timestamp=1669712767833" alt="" srcset="">
                        <span  class="liveDowns">扫码下载</span>
                      </div>
                      <div class="itemAPP" style="margin-left: 46px;">
                        <span  class="livetitles">龙珠直播</span>
                        <img src="https://oss.ansongqiubo.com/apk/iosUploadQrcode/iosQRcode.png?Timestamp=1669712767833" alt="" srcset="">
                        <span  class="liveDowns">扫码下载</span>
                      </div>
                  </div>
                  <div slot="reference" style="display: flex;flex-direction:column;align-items: center;justify-content: center;" class="nav_item elementHove">
                      <img style="width: 20px;height: 20px;" class="oldel" src="@/assets/img/nav/xiazai1.png" alt="" srcset="">
                      <img style="width: 20px;height: 20px;" class="newel" src="@/assets/img/nav/xiazai2.png" alt="" srcset="">
                      <span style="font-size: 14px;">下载</span>
                  </div>
              </el-popover>
            </div>
            <div @click="Shangcheng" :class="routerType == 5 ? 'activeItem' : ''" class="nav_item" v-if="false">
              商城
            </div>
           <!-- <div class="nav_item" @click="Pay">
              充值
            </div> -->
            <div v-if=" yonghuData &&
                yonghuData.userInfo &&
                yonghuData.userInfo.nickname" >
                <el-popover  @show='openreceivetask' placement="top-end" width="400" trigger="hover" popper-class="popTaskBox">
              	  <receivetask  :class="{'filterbgs':grayTheme && routerPath =='/' }"  @openiframe='openiframe' @changeDialog='changeDialog' ref="receivetask"></receivetask>
                  <div slot="reference" class="nav_item showchild elementHove" style="display: flex;flex-direction:column;align-items: center;justify-content: center;">
                    <img style="width: 20px;height: 20px;" class="oldel" src="@/assets/img/nav/renwu1.png" alt="" srcset="">
                    <img style="width: 20px;height: 20px;" class="newel" src="@/assets/img/nav/renwu2.png" alt="" srcset="">
                    <span style="font-size: 14px;">任务</span>
              	</div>
              </el-popover>
            </div>
            <div @click="opentesk"  class="nav_item showchild elementHove" v-else style="display: flex;flex-direction:column;align-items: center;justify-content: center;">
              <img style="width: 20px;height: 20px;" class="oldel" src="@/assets/img/nav/renwu1.png" alt="" srcset="">
              <img style="width: 20px;height: 20px;" class="newel" src="@/assets/img/nav/renwu2.png" alt="" srcset="">
              <span style="font-size: 14px;">任务</span>
            </div>
          <!--  <div class="nav_item" @click="toCreateVideo">
              创作中心
            </div> -->
            <div class="bg-purple2-5" style="background-color: #c699ff;" @mouseenter="Userinfo(true)" :class="{'filterbgs':grayTheme && routerPath =='/'  }">
              <div v-if="yonghuData.userInfo" >
                <img v-if="yonghuData.userInfo && yonghuData.userInfo.avatar" @click="Longin" :src="
                    yonghuData.userInfo.avatar
                      ? yonghuData.userInfo.avatar
                      : 'https://oss.ansongqiubo.com/assets/touxiang2.png'
                  " alt="" />
                <img v-else @click="Longin" src="https://oss.ansongqiubo.com/assets/touxiang2.png" alt="" />
              </div>
              <div v-else class="showLogindialog" :class="Showislogin?'':'showuserLogins'">
                  <img  @click="Longin" src="https://oss.ansongqiubo.com/assets/touxiang.png" alt="" />
                  <div class="noemits"></div>
                  <div class="noLoginDialog">
                    <div class="titleLogin">
                      登录后可享受:
                    </div>
                    <div class="cellitems">
                      <img style="width: 16px;height: 16px;" src="/static/home/video.webp" alt="" srcset=""> 百兆光纤高清画质
                    </div>
                    <div class="cellitems">
                       <img style="width: 16px;height: 16px;"  src="/static/home/jiangbei.webp" alt="" srcset=""> 全球赛事超前订阅
                    </div>
                    <div class="cellitems" style="margin-bottom: 12px;">
                       <img style="width: 16px;height: 16px;"  src="/static/home/times.webp" alt="" srcset=""> 24小时比赛不间断
                    </div>
                    <div class="btnlogins"  @click="Longin">
                      登录
                    </div>
                    <div class="reigist">
                      <img style="width: 8px;height: 7px;" src="/static/home/leftAdd.webp" alt="" srcset="">
                      <span  @click="Longin">点我注册</span>
                      <img  style="width: 8px;height: 7px;transform:rotate(180deg);"  src="/static/home/leftAdd.webp" alt="" srcset="">
                    </div>
                  </div>
              </div>
              <div v-if=" yonghuData &&
                yonghuData.userInfo &&
                yonghuData.userInfo.nickname" class="home-top-longin">
                <div class="emitheight"></div>
                <div class="home-top-longin-div">
                  <div class="home-top-longin-div-top">
                    <div class="popup_center_header">
                      <div style="display: flex">
                        <img v-if="
                            yonghuData.userInfo && yonghuData.userInfo.avatar
                          " :src="yonghuData.userInfo.avatar" alt="" />
                        <img v-else src="https://oss.ansongqiubo.com/assets/touxiang2.png" alt="" />
                      </div>
                      <div class="title_right" v-if="yonghuData.userInfo">
                        <div class="top_name">
                          <div class="name useall">
                            {{ yonghuData.userInfo.nickname }}
                          </div>
                          <div class="home-top-longin-div-top-center-right">
                            <img style="border-radius: 0;" :src="'/static/newhome/l' +  yonghuData.userInfo.level + '.webp'
                              " alt="" />
                          </div>
                        </div>
                        <div class="bottom_progress">
                          <div class="home-top-longin-div-top-center">
                            <div class="home-top-longin-div-top-center-left">
                              LV.{{ yonghuData.userInfo.level }}
                            </div>
                          </div>
                          <div class="home-top-longin-div-top-center-center">
                            <div class="jingyantiao">
                              <el-progress :text-inside="true" :stroke-width="6" class="el-bg-inner-running"
                                :percentage="fifpercentage(yonghuData.userInfo)"></el-progress>
                            </div>
                          </div>
                          <div class="home-top-longin-div-top-center-left">
                            LV.{{ yonghuData.userInfo.level + 1 }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mypay_moneys">
                      <div class="home-top-longin-div-top-bottom">
                        <div class="home-top-longin-div-top-bottom-left">
                          我的钱包
                        </div>
                        <div v-if="moneyData" class="moneyData">
                          {{ moneyData.dragonCoin }}龙币
                        </div>
                      </div>
                      <div @click="Pay" class="home-top-longin-div-top-bottom-right" style="cursor: pointer">
                        充值
                      </div>
                    </div>
                  </div>
                  <div class="home-top-longin-div-bottom">
                    <div @click="GerenRouter" class="vitem" @mouseleave="Geren1" @mouseenter="Geren">
                      <img v-show="geren" src="https://oss.ansongqiubo.com/assets/home/icon_geren_wu.png" />
                      <img v-show="geren1" src="https://oss.ansongqiubo.com/assets/home/icon_geren_ke@2x.png" />
                      <div class="person">个人中心</div>
                    </div>
                    <div @click="GuanzhuRouter" class="vitem" @mouseenter="Guanzhu" @mouseleave="Guanzhu1">
                      <img v-show="guanzhu" src="https://oss.ansongqiubo.com/assets/home/icon_guanzhu_wu@2x.png"
                        alt="" />
                      <img v-show="guanzhu1" src="https://oss.ansongqiubo.com/assets/home/icon_guanzhu_ke@2x.png"
                        alt="" />
                      <div class="person">我的关注</div>
                    </div>
                    <div @click="XiaoxiRouter" class="vitem" @mouseenter="Xiaoxi" @mouseleave="Xiaoxi1">
                      <img v-show="xiaoxi" src="https://oss.ansongqiubo.com/assets/home/icon_lingdang.png" alt="" />
                      <img v-show="xiaoxi1" src="https://oss.ansongqiubo.com/assets/home/icon_xiaoxi_ke@2x.png"
                        alt="" />
                      <div class="person">我的资产</div>
                    </div>
                    <div @click="KaiboRouter" class="vitem" @mouseenter="Zhibo" @mouseleave="Zhibo1">
                      <img v-show="zhibo" src="https://oss.ansongqiubo.com/assets/home/livevideo.png" alt="" />
                      <img v-show="zhibo1" src="https://oss.ansongqiubo.com/assets/home/icon_zhibo_ke@2x.png" alt="" />
                      <div class="person">我要开播</div>
                    </div>
                  </div>
                  <div class="logout" @click="Logout">
                    <div class="btnout">退出登录</div>
                    <div class="show">
                      <img src="https://oss.ansongqiubo.com/assets/home/icon_tuichu_wu@2x.png" alt="" />
                    </div>
                    <div class="hidden">
                      <img src="https://oss.ansongqiubo.com/assets/home/icon_tc_ke@2x.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 备用 -->
   <!--       <div class="beitong" v-if="routerType == 1">
            <div>备用网址1:<a href="https://www.lz.live" target>lz.live</a></div>
            <div>备用网址2:<a href="https://www.kq.live" target>kq.live</a></div>
          </div> -->
        </div>
      </div>
    </div>
    <div v-show="zhibotishi" @click="$router.replace('/tianjiazhiboyuan')" style="
        cursor: pointer;
        border: 2px black solid;
        position: absolute;
        z-index: 10;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        background: #ffffff;
        bottom: 100px;
        left: 20px;
        overflow: hidden;
      ">
      <div style="height: 60%; width: 100%; text-align: center; margin-top: 5px">
        <img style="height: 100%" src="https://oss.ansongqiubo.com/pc-imag/no-avatar.jpg.jpg" alt="" />
      </div>
      <div style="width: 100%; text-align: center; font-size: 14px; color: #999">
        正在直播
      </div>
    </div>
    <div class="joinTowecode" v-if="routerPath =='/'">
      <JoinQrcode @login='Longin()'></JoinQrcode>
    </div>
    <Longin v-show="longin" @longi="longins" @updataName='updataName'></Longin>
    <Pay v-show="pay" :qrcode_url="qrcode_url" :pay="pay" @changeLoad='changeLoad' @pay="pays" :moneyData="moneyData"></Pay>
    <activedialog ref="myactivedialog"></activedialog>
    <div v-show="bindingmobile" style="
        position: absolute;
        z-index: 1000;
        top: calc(50%);
        transform: translateY(50%);
        left: calc(50% - 360px / 2);
        height: 368px;
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 1);
        width: 360px;
        box-sizing: border-box;
        padding: 20px;
      ">
      <div style="width: 100%; height: 10px; text-align: right">
        <img @click="bindingmobile = false" src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" />
      </div>
      <div style="color: #333333; font-size: 28px">绑定手机号</div>
      <div style="margin-top: 30px; font-size: 18px; color: #666666">
        为了您的账号安全，请绑定手机号码
      </div>
      <div style="margin-top: 20px">
        <input style="
            width: 304px;
            height: 40px;
            background: #f2f2f2;
            border-radius: 4px;
            border: none;
            outline: none;
            box-sizing: border-box;
            padding-left: 15px;
          " type="text" v-model="mobile" placeholder="请输入手机号" maxlength="11"
          onkeyup="this.value=this.value.replace(/\D/g,'')" />
      </div>
      <div style="display: flex; margin-top: 20px">
        <div>
          <input placeholder="请输入验证码" style="
              width: 198px;
              height: 40px;
              background: #f2f2f2;
              border-radius: 4px 0 0 4px;
              border: none;
              outline: none;
              box-sizing: border-box;
              padding-left: 15px;
            " type="text" v-model="verify" onkeyup="this.value=this.value.replace(/\D/g,'')" />
        </div>
        <div v-if="yanzhengma" @click="clickVerify" style="
            cursor: pointer;
            width: 106px;
            height: 40px;
            background: #721edc;
            font-size: 14px;
            border-radius: 0px 4px 4px 0px;
            text-align: center;
            line-height: 40px;
          ">
          获取验证码
        </div>
        <div v-else style="
            width: 106px;
            height: 40px;
            background: #c699ff;
            font-size: 14px;
            border-radius: 0px 4px 4px 0px;
            text-align: center;
            line-height: 40px;
          ">
          {{ btnTitle }}
        </div>
      </div>
      <div style="
          height: 45px;
          line-height: 45px;
          font-size: 12px;
          color: #f40000;
          box-sizing: border-box;
          padding-left: 15px;
        ">
        {{ this.hint }}
      </div>
      <button @click="BindingMobile" style="
          cursor: pointer;
          width: 304px;
          height: 40px;
          background: #721edc;
          border-radius: 4px;
          border: 0;
          color: #ffffff;
        ">
        绑定
      </button>
    </div>
    <div v-show="tishi" style="
        position: absolute;
        z-index: 1001;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      ">
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png" alt="" />
      <div style="margin-top: 20px">绑定成功</div>
    </div>
    <lzUpdataNickName ref="openUpdata"></lzUpdataNickName>
    <!-- 活动h5 -->
  </div>
</template>

<script>
  // import axios from 'axios'
  import qs from "qs";
  import Longin from "../component/Longin.vue";
  import Pay from "../component/Pay.vue";
  import Noticeboard from "../component/Noticeboard.vue";
  import Noticeboard1 from "../component/Noticeboard1.vue";
  import JoinQrcode from "../component/JoinQrcode.vue";
  import receivetask from '@/pages/components/lz_receivetask.vue'
  import lzUpdataNickName from '@/pages/components/lz_updataNickName.vue'
  import activedialog from '@/pages/components/lz_activeDialog.vue'
  import { configList } from "@/api/fans.js";
  import $ from "jquery";
  // import axios from 'axios'
  export default {
    props: ["shangchengPay", "rType", 'minwith'],
    inject: ["reload"],
    watch: {

    },
    data() {
      return {
        ShowTask:false,
        Showislogin:false,
        TimeIndex:null,
        statusTab: 1,
        pageid: {},
        bindingmobile: false,
        routerType: 1,
        tishi: '',
        verify: '',
        yanzhengma: true,
        mobile: '',
        btnTitle: '',
        hint: '',
        input: "",
        longin: false,
        pay: false,
        disabled: false,
        userinfo: false,
        wallet: false,
        history: false,
        download: false,
        geren: true,
        guanzhu: true,
        xiaoxi: true,
        zhibo: true,
        geren1: false,
        guanzhu1: false,
        xiaoxi1: false,
        zhibo1: false,
        yonghuData: [], //用户基本信息
        denglutai: "", //登陆态
        historyData: [], //历史观看记录
        sousuoxinxi: "", //搜索信息
        moneyData: [], //龙币详情
        qrcode_url: "", //二维码地址
        touxiang: false,
        noticeboar: true,
        noticemin: false,
        isnoticeopen: "0",
        erweimatanchuang: false,
        zhibotishi: false,
        hoverTimes:null,
        ExpPercentage: 0, //升级到下一级的百分比
        routerPath:'/',
      };
    },
    computed:{
      grayTheme(){
        let data = JSON.parse(localStorage.getItem('userSettingInfo') || {}) ; // grayTheme
         return data && data.grayTheme
      }
    },
    created() {
    // document.getElementById("myframe").scrolling="no";

      this.routerPath = this.$route.path
      // 获取路由参数
      let pageid = this.$route.query;
      this.statusTab = this.$route.query;
      if (this.rType) {
        this.routerType = Number(this.rType);
      }
      if (pageid.rid > 0) {
        this.routerType = Number(pageid.rid);
      }
      console.log('statusTab', this.statusTab, this.routerType);
      this.denglutai = localStorage.getItem("token");
      if (localStorage.getItem("token")) {
        this.touxiang = true;
        this.getUserInfo();
        // 获取敏感词信息
        // if (this.$store.state.WordList && this.$store.state.WordList.roomSendlist.length == 0) {
          this.$store.dispatch('setWordList');
        // }
      } else {
        console.log("没有登陆");
        this.touxiang = false;
        if (this.$route.query.login == 1) {
          this.Longin()
        }
      }
      this.initwechat();

      // 默认打开去登陆
      setTimeout(()=>{
        this.Showislogin = true
      },5000)
    },
    methods: {
      // 获取活动中心
      getActives(){
        location.href = '/v2/act'
        return
        let token  = localStorage.getItem('token');
        if(!token){
          this.Longin()
          return
        }
        configList({}).then(result=>{
          if(result.data.code == 200){
            console.log('当前任务活动',result.data.data);
            let arrs =  result.data.data;
            var states = true;
            arrs.some(item=>{
              let {activityType,state} =item;
              if(activityType == 1 ){
                if(state == 0){
                  let iframeUrl = `http://t-new.longzhu.com/act/#/activity/1?plat=pc&t=${token}`;
                  this.openiframe(iframeUrl);
                  states = false;
                }
              }
            })
           setTimeout(()=>{
             if(states){
               this.$message.error('当前没有可参与的活动，敬请期待~'+states)
             }
           },100)

          }else{
            console.log('检查活动',result.data.message);
          }
        })
      },
      openiframe(val){
        this.$refs.myactivedialog.openiframe(val)
      },
      fifpercentage(item){
        if(item){
          return Number((item.exp / item.nextLevelExp) * 100)
        }
      },
      changeDialog(v){
        console.log('状态',v);
        switch (v) {
          case 1:
            console.log("修改昵称");
            this.$refs.openUpdata.open();
            break;
          case 2:
            console.log("成功修改头像");
            // this.$router.push('/xiugaipersonalc')
            this.$NewRouter(`/v2/my/base`);
            break;
          case 3:
            console.log("首次充值");
            this.Pay()
            break;
          case 4:
            this.$message.success('去给喜欢的主播送礼物吧！')
            console.log("首次送礼");
            break;
          case 5:
            console.log("首次关注主播");
            this.$message.success('去关注喜欢的主播吧！')
            break;
          case 6:
            this.$message.success('去直播间发言吧！')
            console.log("首次发送弹幕");
            break;
          default:
            break;
        }
      },
      openreceivetask(e){
        console.log('我的消息',e);
        if(this.hoverTimes){
          clearTimeout(this.hoverTimes)
        }
        this.hoverTimes = setTimeout(()=>{
          this.$refs.receivetask.open()
        },100)
      },
      opentesk(){
        this.Longin()
      },
      updataName() {
          console.log('打开修改昵称弹框');
          this.$refs.openUpdata.open();
      },
      // 创作中心
      toCreateVideo() {
        if (!localStorage.getItem("token")) {
          this.Longin()
          return false
        }
        if(this.yonghuData.userInfo.identity == 2){
          // this.$NewRouter(`/v2/my/base/info`);

          // const neww = this.$router.resolve({
          //   path: 'centervideo',
          //   query: {
          //     id: 0,
          //     tab: 0,
          //     pagestatus: '/centerContent',
          //   }
          // })
          // window.open(neww.href, "_self");
        }else{
          // const neww = this.$router.resolve({path:'anchor'})
          // window.open(neww.href, "_self");
          this.$message.error('请先成为主播')
        }
      },
      getUserInfo(state) {
          state = state?2:1
          this.$store.dispatch('getUserInfoData',state).then(async (result) => {
          console.log('获取用户信息', result,state);
          this.yonghuData = result;
          this.$emit("roomid", result.userInfo.uid);
          this.$emit("identity",result.userInfo.identity);
          this.$emit("avatar", result.userInfo.avatar);
          this.$emit("mobile", result.userInfo.mobile);
          this.ExpPercentage = Math.round(
            Math.round(
              (this.yonghuData.userInfo.exp /
                this.yonghuData.userInfo.nextLevelExp) *
              10000
            ) / 100.0
          );
        });
      },
      // userData
      // 发送验证码
      clickVerify() {
        const reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
        if (this.mobile == '' || this.mobile.length <= 10 || !reg.test(this.mobile)) {
          this.hint = '手机号码错误'
        } else {
          this.hint = ''
          this.yanzhengma = false
          let time = 60;
          let timer = setInterval(() => {
            if (time == 0) {
              clearInterval(timer);
              this.yanzhengma = true
              this.btnTitle = "60s"
            } else {
              this.btnTitle = time + "s";
              time--;
            }
          }, 1000)
        }
        this.$axios({
          headers: {
            "device": "web",
            "packageId": "1",
            "version": "1.0.0",
            "channel": "web",
            "authToken": localStorage.getItem('token'),
            "Content-Type": "application/x-www-form-urlencoded"
          },
          transformRequest: [function(data) { //在请求之前对data传参进行格式转换
            data = qs.stringify(data)
            return data
          }],
          url: this.api + '/v1/third/bindThirdSmsCode',
          method: 'post',
          data: {
            mobile: this.mobile
          }
        }).then(res => {
          console.log(res);
        })
      },
      // 绑定手机号
      BindingMobile() {
        this.$axios({
          headers: {
            "device": "web",
            "packageId": "1",
            "version": "1.0.0",
            "channel": "web",
            "authToken": localStorage.getItem('token'),
            "Content-Type": "application/x-www-form-urlencoded"
          },
          transformRequest: [function(data) { //在请求之前对data传参进行格式转换
            data = qs.stringify(data)
            return data
          }],
          url: this.api + '/v1/third/bindUser',
          method: 'post',
          data: {
            code: this.code,
            mobile: this.mobile,
            token: this.verify,
            thirdName: "wechat"
          }
        }).then(res => {
          // console.log(res);
          if (res.data.message == "success") {
            localStorage.setItem('token', res.data.data.lzid)
           this.getUserInfo(2)
            this.tishi = true
            this.bindingmobile = false
            setTimeout(() => {
              this.tishi = false
            }, 2000)
          } else {
            this.hint = res.data.message
          }
        })
      },
      userData2() {
        if (localStorage.getItem("token")) {
          this.touxiang = true;
          // this.$axios({
          //   url: this.api + "/v1/profile/user",
          //   method: "GET",
          //   headers: {
          //     "authToken": localStorage.getItem("token"),
          //     "Content-Type": "application/json",
          //   },
          // }).then((res) => {
          //   console.log('获取用户信息2', res);
          //   this.yonghuData = res.data.data;
          //   this.$emit("roomid", res.data.data.userInfo.uid);
          //   this.$emit("identity", res.data.data.userInfo.identity);
          //   this.$emit("avatar", res.data.data.userInfo.avatar);
          //   this.$emit("mobile", res.data.data.userInfo.mobile);
          //   this.ExpPercentage = Math.round(
          //     Math.round(
          //       (this.yonghuData.userInfo.exp /
          //         this.yonghuData.userInfo.nextLevelExp) *
          //       10000
          //     ) / 100.0
          //   );
          // }).catch((err) => {
          //   console.log('用户错误');
          //   localStorage.clear('token');
          // })
          // 获取龙币余额
          this.$axios({
            url: this.api + "/v1/wallet/info",
            method: "GET",
            headers: {
              "authToken": localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
          }).then((res) => {
            // console.log(res);
            this.moneyData = res.data.data;
          });
        } else {
          console.log("没有登陆");
          this.touxiang = false;
        }
      },
      initwechat() {
        // 微信一键登录
        var url = location.search; //获取url中"?"符后的字串，包含？号本身。
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
          var str = url.substr(1);
          var strs = str.split("&");
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURIComponent(
              strs[i].split("=")[1]
            );
          }
        }
        // console.log(theRequest);
        if (theRequest.code) {
          this.code = theRequest.code;
          this.$axios({
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                return data;
              },
            ],
            url: this.api + "/v1/third/login",
            method: "post",
            data: {
              code: theRequest.code,
              thirdName: "wechat",
            },
          }).then((res) => {
            // console.log(res);
            if (res.data.message == "success") {
              localStorage.setItem("token", res.data.data.lzid);
              this.getUserInfo(2)
              // this.yonghuData = res.data.data
            }
            if(res.data.code == 20311) {
             this.bindingmobile = true;
            }
          });
        }
      },
      closenotice() {
        this.noticeboar = false;
        this.noticemin = true;
      },
      // 搜索数据
      sousuo() {
        if (this.sousuoxinxi) {
          this.$axios({
            url: this.api + "/v1/list/search/user?nickname=" + this.sousuoxinxi,
            method: "GET",
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
          }).then((res) => {
            // console.log(res);
            this.$emit("Data", res.data.data);
            this.$emit("sousuoxinxi", this.sousuoxinxi);
            console.log(this.sousuoxinxi);
            if (this.$route.path == "/search") {
              // console.log(123);
            } else {
              sessionStorage.setItem("searchData", JSON.stringify(res.data.data));
              this.$router.push({
                path: "/search",
                query: {
                  data3: this.sousuoxinxi
                },
              });
            }
          });
        } else {
          alert("请输入内容");
        }
      },
      // 退出登陆
      Logout() {
        location.href = '/v2'
        localStorage.clear()
        if (localStorage.getItem("token")) {

          localStorage.removeItem("token");
          localStorage.removeItem("userData");
          console.log("退出成功");
          this.yonghuData = {};
          // this.$router.push("/");
          // this.$NewRouter(`/v2`);
          this.$store.commit('logout');
          this.reload();
        } else {
          localStorage.clear()
        }
      },
      // 下载app显示隐藏
      Download() {
        this.download = true;
      },
      Download1() {
        this.download = false;
      },
      downloadApp() {
        this.$router.push({
          path: "/download"
        });
      },
      pageRouter(query) {
        this.$store.commit('pageRouter', {
          type: 1,
          query,
        })
      },
      goScoreHome(v){
        if(v==1){
        	location.href =  "/pageScore?rid=2";
        }else{
          location.href =  "/v2/lanqiu?rid=2";
        }
      },
      chePage(e) {
        if (e == 1) {
          // window.open(`${this.Tourl}/?rid=${e}`);
          this.$NewRouter(`/v2`);
          // this.$router.replace({
          //   path: '/',
          //   query: {
          //     rid: 1,
          //   }
          // })
        }
        if (e == 2) {
          this.pageRouter({
            path: '/pageScore',
            query: {
              rid: 2
            }
          })
        }
        if (e == 3) {
          // 资讯中心
          this.pageRouter({
            path: '/informationlist',
            query: {
              rid: 3,
              infoId: 0,
              valId: 1
            }
          })
        }
        if (e == 4) {
          // 直播分类

          this.$NewRouter(`/v2/lives/all`);


          // this.pageRouter({
          //   path: '/pageLive',
          //   query: {
          //     rid: 1,
          //     infoId: 1,
          //     valId: ''
          //   }
          // })
        }
        if (e == 8) {
          this.pageRouter({
            path: 'kaiboHelp',
            query: {
              rid: 8
            }
          })
        }
        if (e == 9) {
          this.pageRouter({
            path: 'pageFull', // 'download',
            query: {
              rid: 9
            }
          })
        }
        this.$store.dispatch("changePage", e);
      },
      Shouye() {
        // window.location.href = "/";
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/room/leave",
          method: "post",
          data: {
            roomId: 80,
          },
        }).then((res) => {
          // console.log(res);
        });
      },
      Shangcheng() {
        this.$router.push({
          name: "shangcheng"
        });
      },
      Chakanlishi() {
        this.$router.push({
          name: "lishiguankan"
        });
      },
      Longin() {
        // console.log(this.yonghuData);
        if (localStorage.getItem("token")) {
          this.longin = false;
          // this.pay = false;
          this.$NewRouter(`/v2/my/base`);
          // this.$router.push({
          //   name: "gerenyemian"
          // });
          // console.log(123);
        } else {
          this.longin = true;
          this.pay = false;
        }
      },
      longins(e) {
        this.longin = false;
        if (e == true && localStorage.getItem("token")) {
           this.$store.dispatch('getUserInfoData',1).then((result) => {
            console.log('获取用户信息1', result);
            this.yonghuData = result;
            this.$emit('changeLogin')
          });
        }
      },
      Pay() {
        // window._czc.push(['A0204', contentUrl, refererUrl])
        if (localStorage.getItem("token")) {
          // this.$axios({
          //   headers: {
          //     device: "web",
          //     packageId: "1",
          //     version: "1.0.0",
          //     channel: "web",
          //     "authToken": localStorage.getItem("token"),
          //     "Content-Type": "application/x-www-form-urlencoded",
          //   },
          //   transformRequest: [
          //     function(data) {
          //       //在请求之前对data传参进行格式转换
          //       data = qs.stringify(data);
          //       return data;
          //     },
          //   ],
          //   url: this.payGateway + "/v1/payment/trade",
          //   method: "post",
          //   data: {
          //     user_id: this.yonghuData.userInfo.uid,
          //     amount: "5000",
          //     desc: "50000",
          //     method: "ali_adapay_qr",
          //     // method: "wx_qr"
          //   },
          // }).then((res) => {
          //   console.log(res);
          //   this.qrcode_url = res.data.data.qrcode_url;
          // });
          this.longin = false;
          this.pay = true;
        } else {
          this.Longin()
        }
      },
      // 支付结果
      changeLoad(type){
        this.$emit('changeLoad',type)
      },
      pays(e) {
        this.pay = e;
      },
      History() {
        if (localStorage.getItem("token")) {
          this.history = true;
        } else {
          this.history = false;
        }
      },
      History1() {
        this.history = false;
      },
      Wallet() {
        if (localStorage.getItem("token")) {
          this.wallet = true;
        } else {
          this.wallet = false;
        }
      },
      Wallet1() {
        this.wallet = false;
      },
       Userinfo(state) {
        if(this.TimeIndex){
          clearTimeout(this.TimeIndex)
        }
        console.log('我擦');
        this.TimeIndex = setTimeout(async ()=>{
          console.log('鼠标移入了。。。。');
          if (localStorage.getItem("token")) {
            this.userinfo = true;
            let resultMoeys = await this.$store.dispatch('getUserMoneyData',2);
            console.log('我余额数据', resultMoeys);
            this.moneyData = resultMoeys;
            this.getUserInfo(state);
          } else {
            this.userinfo = false;
          }
        },500)
      },
      Userinfo1() {
        this.userinfo = false;
      },
      Geren() {
        this.geren = false;
        this.geren1 = true;
      },
      Guanzhu() {
        this.guanzhu = false;
        this.guanzhu1 = true;
      },
      Xiaoxi() {
        this.xiaoxi = false;
        this.xiaoxi1 = true;
      },
      Zhibo() {
        this.zhibo = false;
        this.zhibo1 = true;
      },
      Geren1() {
        this.geren = true;
        this.geren1 = false;
      },
      Guanzhu1() {
        this.guanzhu = true;
        this.guanzhu1 = false;
      },
      Xiaoxi1() {
        this.xiaoxi = true;
        this.xiaoxi1 = false;
      },
      Zhibo1() {
        this.zhibo = true;
        this.zhibo1 = false;
      },
      GerenRouter() {
        this.$NewRouter(`/v2/my/base`);
        // this.$router.push({
        //   path: "/personalc?id=0&tab=0"
        // });
      },
      GuanzhuRouter() {
        this.$NewRouter(`/v2/my/mycare`);
        // this.$router.push({
        //   name: "wodeguanzhu"
        // });
      },
      XiaoxiRouter() {
        this.$NewRouter(`/v2/my/myassets`);
        // this.$router.push({
        //   name: "wodexinxi"
        // });
      },
      KaiboRouter() {
        if (!localStorage.getItem("token")) {
          this.Longin()
          return;
        }
        // 判断是否是主播
        console.log('用户信息',this.yonghuData);
        if(this.yonghuData &&  this.yonghuData.userInfo && this.yonghuData.userInfo.identity == 2 ){


          this.$NewRouter(`/v2/my/showset`);

          // this.pageRouter({
          //   path: '/tianjiazhiboyuan',
          //   query: {
          //     id: 8,
          //     tab: 2,
          //   }
          // })
        }else{

          this.$NewRouter(`/v2/my/anchor/join`);
          // this.pageRouter({
          //   path: '/anchor',
          // })
        }
      },
    },
    components: {
      Longin,
      Pay,
      Noticeboard,
      Noticeboard1,
      JoinQrcode,
      lzUpdataNickName,
      receivetask,
      activedialog
    },
    watch: {
    '$route.path': function (newval, oldval) {

        console.log('路由变化');
       if (newval == '/') {
        console.log('进入首页');
       }
       if (newval == '/pageLive' || newval == '/roominfo') {
        console.log('进入直播页');
       }
      },
      shangchengPay(val, newval) {
        // console.log(val)
        this.Pay();
      },

    },
  };
</script>

<style lang="scss" >
  @import "../assets/style/index.scss"; //引入全局scss
.popScopeSelectBox{
	padding: 0;
	min-width: 0px;
	width:100px !important;
	.dioalogBox{
		display: flex;
		flex-direction: column;
		padding: 6px 0;
		.footBall:hover{
			color: #721EDC;
		}
		.footBall{
			cursor: pointer;
			height: 34px;
			line-height: 34px;
			text-align: center;
		}
	}
}
  .myoldHeaders{
    width: 100%;
    background: $bgNav;
    position: fixed;
    top: 0px;
    z-index: 1999;
    height: 68px;
    min-height: 68px;
    max-height: 200px;
    min-width: 1150px;
    display: flex;
    align-items: center;
    a {

       text-decoration: none;
     }
     ::-webkit-scrollbar {
         /*滚动条整体样式*/
         width: 3px;
         /*高宽分别对应横竖滚动条的尺寸*/
         height: 8px;

       }
       ::-webkit-scrollbar-thumb {
         /*滚动条里面小方块*/
         border-radius: 10px;
         //background-color: #8c8c8c;
         background-color: rgba(0, 0, 0, 0.25);
       }

       ::-webkit-scrollbar-track {
         background-color: #f6f6f6;
       }

       ::-webkit-scrollbar-thumb,
       ::-webkit-scrollbar-track {
         border: 0;
     }

     .iframeUrlBox{
       position: fixed;
       left: 0;
       right: 0;
       bottom: 0;
       top: 0;
       z-index: 999;
       background-color: rgba(0, 0, 0, 0.55);
     }
     .closeiframe{
       position: fixed;
       left: 50%;
       top: 24vh;
       transform: translate(220px,-40px);
       img{
         width: 40px;
         height:40px;
       }
     }
     .iframeUrl{
       position: fixed;
       left: 50%;
       top: 24vh;
       transform: translateX(-50%);
     }

     .home-top {
       display: flex;
       /* flex-direction: row; */
       /* flex-wrap: nowrap; */
       height: 100%;
       width: 100%;
       align-items: center;
       justify-content: center;
       position: relative;

       // box-shadow: 0px 10px 20px 0px rgba(130, 130, 130, 0.1);
       .maxnoneWidth {
         max-width: 100% !important;
         padding-right: 24px;
         box-sizing: border-box;
         .bg-purple1{
           transition: all .3s;
           display: flex;
           height: 80px;
           justify-content: center;
           width: 240px;
           align-items: center;
           // border-right: 1px solid #DADADA;
           margin-right: 14px;
         }
       }

       .maxwidth {
         max-width: 1200px;
         box-sizing: border-box;
         height: 100%;
         flex: 2;
         user-select: none;
         display: flex;
         align-items: center;
         justify-content: space-between;

         .activeItem {
           color: #721edc !important;
         }

         .nav_leftitem {
           display: flex;
           align-items: center;

           .itemName {
             height: 16px;
             font-size: 16px;
             font-family: PingFangSC-Medium, PingFang SC;
             font-weight: 500;
             color: #666666;
             line-height: 16px;
             cursor: pointer;
             margin-right: 30px;

             a {
               color: #666666;
               text-decoration: none;
             }

             a:active {
               color: #666666;
             }

             a:hover {
               color: #721edc;
             }
           }

           .itemName:hover {
             color: #721edc;
           }
         }

         .header_logo {
           display: flex;
         }

         .right_nav {
           display: flex;
           align-items: center;
           position: relative;
           height: 100%;
           .hidden_input {
             position: absolute;
             top: -9999px;
           }
         }

         .beitong {
           position: absolute;
           right: -60px;
           transform: translatex(80px);
           display: flex;
           flex-direction: column;
           font-size: 14px;

           a {
             text-decoration: none;
             color: #e9463a;
             font-weight: bold;
           }
         }

         .home-search {
           cursor: pointer;
           width: 60px;
           height: 32px;
           position: absolute;
           right: 0;
           background: linear-gradient(270deg, #a051ff 0%, #721edc 100%);
           border-radius: 16px;
           display: flex;
           // transform: translateX(-60px);
           align-items: center;
           justify-content: center;
           font-size: 14px;
           font-family: PingFangSC-Regular, PingFang SC;
           font-weight: 400;
           color: #ffffff;
         }

         .bg-purple-light {
           display: flex;
           justify-content: center;
           align-items: center;
           background: $bgNav;
           position: relative;
           margin-right: 1vw;
           /* margin-left:506px; */
         }

         .bg-purple2-5:hover {
           .home-top-longin {
             display: block !important;
           }
         }

         .bg-purple2-5 {
           width: 40px;
           height: 40px;
           border-radius: 50%;
           cursor: pointer;
           border: 1px $bgNav solid;
           /* font-size: 23px; */
           position: relative;
           z-index: 888;

           img {
             border-radius: 50%;
             width: 40px;
             height: 40px;
           }
           .showLogindialog{
             position: relative;
           }
           .showuserLogins{
             .noLoginDialog{
               display: block !important;
             }
           }
           .showLogindialog:hover{
             .noLoginDialog{
               display: block !important;
             }
           }
           .noemits{
             height: 25px;
             // border: 1px solid rebeccapurple;
             width: 178px;
             transform: translateX(-138px);
           }
           .noLoginDialog{
             display: none;
             position: absolute;
             right: 0;
             box-shadow: 0 1px 1px 2px #eee;
             // transform: translateY(25px);
             width: 178px;
             height: 198px;
             background: #FFFFFF;
             border-radius: 4px;
             padding: 12px 16px;
             box-sizing: border-box;
             .reigist{
               margin-top: 8px;
               display: flex;
               justify-content: center;
               align-items: center;
               height: 14px;
               font-size: 10px;
               font-family: PingFangSC-Regular, PingFang SC;
               font-weight: 400;
               color: #3798FF;
               line-height: 14px;
               img{
                 margin: 0 4px;
               }
             }
             .btnlogins{
               width: 138px;
               height: 28px;
               background: #721EDC;
               color: #FFFFFF;
               border-radius: 14px;
               font-size: 14px;
               display: flex;
               justify-content: center;
               align-items: center;
             }
             .cellitems{
               margin-bottom: 12px;
               display: flex;
               align-items: center;
               height: 20px;
               font-size: 14px;
               font-family: PingFangSC-Regular, PingFang SC;
               font-weight: 400;
               color: #333333;
               line-height: 20px;
               img{
                 margin-right: 4px;
                 border-radius: 0;
               }
             }
             .cellitems:last-child{
               margin-bottom: 12px;
             }
             .titleLogin{
               margin-bottom: 12px;
               height: 20px;
               font-size: 14px;
               font-family: PingFangSC-Semibold, PingFang SC;
               font-weight: 600;
               color: #333333;
               line-height: 20px;
             }
           }
         }

         .bg-purple-light-input {
           display: flex;
           font-size: 14px;
           text-indent: 1rem;
           font-family: PingFangSC-Regular, PingFang SC;
           font-weight: 400;
           color: #999999;
           border: none;
           justify-content: center;
           align-items: flex-start;
           outline: none;
           width: 218px;
           height: 32px;
           background: #f2f2f2;
           border-radius: 16px;
           /* text-security:disc; */
           /* -webkit-text-security:disc; */
           /* margin: 6px 0 0 506px; */
         }

         .bg-purple2 {
           background: $bgNav;
           display: flex;
           height: 100%;
           justify-content: right;
           align-items: center;
           justify-content: space-between;
           color: $colorNav;
         }

         .jingyantiao {
           width: 155px;
           margin: 0 4px;
           border-radius: 2px;
         }

         .home-top-longin {
           display: none;
           background: #ffffff;
           width: 332px;
           // height: 274px;
           border-radius: 0px 0px 6px 6px;
           position: absolute;
           right: -0px;
           top: 36px;
           z-index: 10;

           .emitheight {
             height: 24px;
             width: 332px;
             opacity: 0;
           }

           .home-top-longin-div {
             width: 332px;
             height: 274px;
             background: #ffffff;
             box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
             border-radius: 0px 0px 6px 6px;
             box-sizing: border-box;
             padding: 12px 12px 0;
             border-radius: 2px 2px 6px 6px;

             .popup_center_header {
               display: flex;
               align-items: center;

               img {
                 width: 54px;
                 height: 54px;
                 margin-right: 6px;
               }

               .title_right {
                 display: flex;
                 align-items: flex-start;
                 flex-flow: column wrap;

                 .top_name {
                   display: flex;
                   align-items: center;
                   flex: 1;
                   .name {
                     margin-right: 6px;
                     font-size: 16px;
                     font-family: PingFangSC-Regular, PingFang SC;
                     font-weight: 400;
                     color: #333333;
                   }

                   .home-top-longin-div-top-center-right {
                     width: 46px;
                     text-align: center;
                     img{
                       width: 46px;
                       height: 14px;
                     }
                     color: #b3b3b3;
                   }
                 }

                 .bottom_progress {
                   display: flex;
                   margin-top: 6px;
                   align-items: center;

                   .home-top-longin-div-top-center {
                     display: flex;
                     align-items: center;
                     justify-content: space-between;
                   }

                   .home-top-longin-div-top-center-left {
                     display: flex;
                     background: #ffffff;
                     // box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
                     border-radius: 0px 0px 6px 6px;
                     border-radius: 2px;
                     text-align: center;
                     /* border: 1px solid rgba(45, 143, 255, 1); */
                     color: rgba(18, 115, 225, 1);
                     font-size: 14px;
                   }
                 }
               }
             }

             .logout {
               display: flex;
               width: 308px;
               justify-content: center;
               border-top: solid 1px #f2f2f2;
               align-items: center;
               height: 38px;

               .show {
                 display: block;
               }

               .hidden {
                 display: none;
               }

               .btnout {
                 font-size: 14px;
                 line-height: 35px;
                 height: 100%;
                 font-family: PingFangSC-Regular, PingFang SC;
                 font-weight: 400;
                 color: #666666;
               }

               img {
                 width: 14px;
                 height: 14px;
               }
             }

             .logout:hover {
               .btnout {
                 color: #721edc;
               }

               .show {
                 display: none;
               }

               .hidden {
                 display: block;
               }
             }

             .home-top-longin-div-bottom {
               /* background-color: red; */
               display: flex;
               padding: 20px 0;
               justify-content: space-between;

               .vitem {
                 cursor: pointer;
                 display: flex;
                 flex-flow: column;
                 justify-content: center;
                 align-items: center;

                 .person {
                   font-size: 14px;
                   font-family: PingFangSC-Regular, PingFang SC;
                   font-weight: 400;
                   // color: #721EDC;
                   color: #666;
                 }

                 img {
                   width: 32px;
                   height: 32px;
                   border-radius: 0;
                 }
               }

               .vitem:hover {
                 .person {
                   color: #721edc;
                 }
               }
             }
           }

           .home-top-longin-div-top {
             /* background-color: red; */
             // height: 200px;
             border-bottom: 1px solid #e4e4e4;
             padding-bottom: 12px;
           }

           .mypay_moneys {
             display: flex;
             justify-content: space-between;
             align-items: center;
             margin-top: 20px;
           }

           .home-top-longin-div-top-bottom {
             display: flex;
             justify-content: space-between;
             flex-direction: column;
           }

           .home-top-longin-div-top-bottom-left {
             width: 64px;
             font-size: 16px;
             font-family: PingFangSC-Medium, PingFang SC;
             font-weight: 500;
             color: #666666;
           }

           .moneyData {
             margin-top: 2px;
             font-size: 14px;
             font-family: PingFangSC-Regular, PingFang SC;
             font-weight: 400;
             color: #666666;
           }

           .home-top-longin-div-top-bottom-right {
             font-size: 12px;
             width: 48px;
             height: 24px;
             background: #e6d2ff;
             border-radius: 12px;
             color: #721edc;
             line-height: 24px;
             text-align: center;
           }
         }
       }
     }
    .taskBox{
       position: absolute;
       top: 80px;
       left: -300px;
       width: 400px;
       // min-height: 440px;
       background: #F7F8FA;
       box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.3);
       border-radius: 0px 0px 6px 6px;
     }
     .showchild{
       margin-right: 22px;
       // border: 1px solid red;
     }
     .nav_item {
       display: flex;
       align-items: center;
       height: 100%;
       font-size: 20px;
       position: relative;
       padding:0 15px;
       cursor: pointer;
       font-size: 16px;
       font-family: PingFangSC-Regular, PingFang SC;
       font-weight: 400;
       color: #666666;
       user-select: none;

       .download_APP {
         z-index: 1;
         width: 228px;
         height: 156px;
         background: #ffffff;
         box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
         border-radius: 0px 0px 6px 6px;
         box-sizing: border-box;
         padding: 12px;
         position: absolute;
         right: 0;
         transform: translateX(33%);
         top: 50px;
         display: flex;
         justify-content: space-between;

         .android {
           display: flex;
           flex-direction: column;
           align-items: center;

           img {
             padding: 4px;
             border-radius: 6px;
             border: 1px solid rgba(46, 48, 52, 0.3);
             width: 88px;
             height: 88px;
           }

           .down_txt {
             margin-top: 12px;
             width: 88px;
             height: 24px;
             background: #721edc;
             border-radius: 12px;

             line-height: 24px;
             text-align: center;
             font-size: 12px;
             font-family: PingFangSC-Regular, PingFang SC;
             font-weight: 400;
             color: #ffffff;
           }
         }
       }

       a {
         color: #666666;
         text-decoration: none;
       }

       a:active {
         color: #666666;
       }

       a:hover {
         color: #721edc;
       }
     }

     .nav_item:hover {
       color: #721edc;
     }

     .el-progress {
       width: 100%;
     }

     .el-progress__text {
       color: #fff;
       font-size: 14px;
     }

     .el-progress-bar__outer {
       height: 12px !important;
       border: 1px solid #78335f;
       background-color: transparent;
     }

     .el-bg-inner-error .el-progress-bar__inner {
       background-image: linear-gradient(to right, #3587d8, #fb3a7e);
     }

     .el-bg-inner-done .el-progress-bar__inner {
       background-image: linear-gradient(to right, #3587d8, #53ff54);
     }

     .sanjiao {
       width: 0;
       height: 0;
       border-bottom: 20px solid #721edc;
       border-bottom-width: 27px;
       border-radius: 20px solid transparent;
       border-left: 15px solid transparent;
       border-right: 15px solid transparent;
       position: absolute;
       top: -26px;
       right: 15px;
     }

     .sanjiao2 {
       width: 0;
       height: 0;
       border-bottom: 20px solid #721edc;
       border-bottom-width: 27px;
       border-radius: 20px solid transparent;
       border-left: 15px solid transparent;
       border-right: 15px solid transparent;
       position: absolute;
       top: -26px;
       right: 15px;
     }



     .home-top-longin-div-top-center-center {
       text-align: center;
     }

     .home-top-longin-div-top-center-center-exp {
       width: 162px;
       height: 8px;
       background-color: #d5d5d5;
       border-radius: 10px;
     }

     .home-top-longin-div-top-center-center-exp-exp {
       width: 50%;
       height: 8px;
       background-color: #721edc;
       border-radius: 10px;
     }

     .home-top-wallet {
       width: 190px;
       height: 87px;
       background: #721edc;
       position: absolute;
       top: 55px;
       right: -15px;
       border-radius: 6px;
       z-index: 3;
       box-sizing: border-box;
       padding-top: 5px;
       /* position: relative; */
     }

     .home-top-wallet-div {
       width: 190px;
       height: 82px;
       background-color: white;
       box-sizing: border-box;
       padding: 10px;
       border-radius: 2px 2px 6px 6px;
       position: relative;
     }

     .home-top-history {
       background: #721edc;
       border-radius: 4px;
       position: absolute;
       top: 50px;
       right: 0px;
       z-index: 10;
     }

     .home-top-history-div {
       width: 296px;
       height: 332px;
       background-color: white;
       padding: 10px;
       margin-top: 5px;
       border-radius: 2px 2px 6px 6px;
       position: relative;
     }

     .home-top-history-div-top {
       width: 276px;
       height: 265px;
       margin-top: 10px;
     }

     .home-top-history-div-bottom {
       width: 276px;
       height: 27px;
       text-align: center;
       color: #666666;
       font-size: 14px;
       margin-top: 20px;
     }

     .home-top-history-div-top-div {
       display: flex;
       margin-top: 20px;
       font-size: 14px;
       color: #333333;
     }

     .home-top-history-div-top-div>div {
       margin-top: 2px;
       margin-left: 6px;
       font-size: 14px;
       color: #333333;
     }
     .biglogo{
         display: block;
         width: 140px;
         height: 51px;
         display: flex;
         justify-content: center;
         margin-right: 40px;
         align-items: center;
     }
     .minlogo{
       width: 28px ;
       height: 28px;
       display: none;
     }
     .grid-content {
       /* border-radius: 4px; */
       height: 100%;

     }



     .home-longin {
       width: 474px;
       height: 623px;
       background: #ffffff;
       box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.3);
       border-radius: 12px;
       position: absolute;
       top: 50%;
       left: 50%;
       margin-top: -341.5px;
       margin-left: -267px;
       z-index: 10;
       padding: 30px;
     }

     .home-longin-div1 {
       height: 38px;
       background-color: rgba(0, 0, 0, 0);
       display: flex;
       justify-content: right;
       align-items: center;
     }

     .icon2 {
       width: 28px;
       height: 28px;
     }

     .home-login-h1 {
       width: 352px;
       height: 44px;
       display: block;
       color: #333333;
       font-size: 44px;
       white-space: nowrap;
       line-height: 44px;
       text-align: left;
       align-self: flex-start;
       margin-top: 10px;
     }

     .home-login-div2 {
       width: 330px;
       height: 32px;
       margin-top: 40px;
       display: flex;
       justify-content: center;
       align-items: center;
       justify-content: space-between;
     }

     .home-login-div2-div1 {
       width: 150px;
       height: 32px;
       display: block;
       overflow-wrap: break-word;
       color: rgba(51, 51, 51, 1);
       font-size: 30px;
       white-space: nowrap;
       line-height: 32px;
       text-align: right;
     }

     .home-login-div2-div1-div {
       width: 80px;
       height: 6px;
       border-radius: 3px;
       background-color: rgba(214, 181, 255, 1);
       align-self: flex-start;
       margin-left: 30px;
     }

     .home-login-div2-div1-div2 {
       width: 80px;
       height: 6px;
       border-radius: 3px;
       background-color: rgba(214, 181, 255, 1);
       align-self: flex-start;
       margin-left: 18px;
     }

     .home-login-div2-div2 {
       /* z-index: 225; */
       width: 120px;
       height: 32px;
       display: block;
       overflow-wrap: break-word;
       color: rgba(51, 51, 51, 1);
       font-size: 30px;
       font-family: PingFangSC-Regular;
       white-space: nowrap;
       line-height: 32px;
       text-align: right;
     }

     .home-input1 {
       width: 450px;
       height: 60px;
       font-size: 22px;
       border: none;
       margin-top: 16px;
       background-color: rgba(239, 239, 239, 1);
       justify-content: center;
       align-items: flex-start;
       border-radius: 6px;
       outline: none;
       padding-left: 20px;
     }

     .home-longin-eye {
       position: absolute;
       top: 63%;
       right: 5%;
     }

     .home-longin-eye2 {
       position: absolute;
       top: 50%;
       right: 5%;
     }

     .home-input2 {
       width: 300px;
       height: 60px;
       font-size: 23px;
       padding-left: 20px;
       border: none;
       margin-top: 16px;
       background-color: rgba(239, 239, 239, 1);
       justify-content: center;
       align-items: flex-start;
       border-radius: 6px;
       outline: none;
     }

     .home-input3 {
       width: 450px;
       height: 60px;
       font-size: 22px;
       border: none;
       margin-top: 16px;
       background-color: rgba(239, 239, 239, 1);
       justify-content: center;
       align-items: flex-start;
       border-radius: 6px;
       outline: none;
       padding-left: 20px;
     }

     .home-button2 {
       height: 60px;
       border-radius: 0 6px 6px 0;
       background-color: rgba(114, 30, 220, 1);
       width: 174px;
       justify-content: center;
       align-items: center;
       margin-top: 16px;
       font-size: 23px;
       outline: none;
       border: 0px;
       color: white;
     }

     .home-button2-boton {
       height: 60px;
       border-radius: 0 6px 6px 0;
       background-color: #be9df9;
       width: 174px;
       justify-content: center;
       align-items: center;
       margin-top: 16px;
       font-size: 23px;
       outline: none;
       border: 0px;
       color: white;
     }

     .home-longin-botton3 {
       height: 72px;
       border-radius: 6px;
       background-color: #d4b2ff;
       margin-top: 90px;
       width: 470px;
       justify-content: center;
       align-items: center;
       font-size: 25px;
       color: white;
       outline: none;
       border: 0px;
     }

     .home-longin-botton4 {
       height: 72px;
       border-radius: 6px;
       background-color: #d4b2ff;
       margin-top: 20px;
       width: 470px;
       justify-content: center;
       align-items: center;
       font-size: 25px;
       color: white;
       outline: none;
       border: 0px;
     }

     .home-longin-div3 {
       width: 471px;
       height: 20px;
       display: block;
       overflow-wrap: break-word;
       color: rgba(102, 102, 102, 1);
       font-size: 20px;
       font-family: PingFangSC-Regular;
       white-space: nowrap;
       line-height: 20px;
       text-align: left;
       align-self: flex-start;
       margin-top: 10px;
     }

     .home-longin-div4 {
       width: 552px;
       display: flex;
       justify-content: center;
       align-items: center;
       margin-top: 25px;
     }

     .home-longin-div5 {
       width: 260px;
       height: 70px;
       justify-content: space-between;
       margin: 20px 0 0 146px;
       display: flex;
     }

     .home-longin-div6 {
       width: 470px;
       height: 53px;
       margin-top: 43px;
       justify-content: space-between;
     }

     .home-longin-div6>a {
       text-decoration: none;
     }

     .forget-div1 {
       width: 162px;
       height: 14px;
       color: red;
       font-size: 14px;
       text-align: left;
       margin-top: 8px;
     }
  }

</style>



// WEBPACK FOOTER //
// src/component/Nav.vue